import React from 'react';

import { AUDIO_CREATOR, AUDIO_TITLE } from '../data-hooks';
import styles from '../statics/styles/audio.rtlignore-scss';

interface Props {
  authorName?: string;
  title?: string;
}

const AudioDetails = ({ authorName, title }: Props) => {
  return (
    <div className={styles.audioDetails}>
      {title && (
        <span className={styles.title} data-hook={AUDIO_TITLE} title={title}>
          {title}
        </span>
      )}
      {authorName && (
        <span className={styles.authorName} data-hook={AUDIO_CREATOR} title={authorName}>
          {authorName}
        </span>
      )}
    </div>
  );
};

export default AudioDetails;
